import script from "./PerformerProjectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectForm.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectForm.vue?vue&type=style&index=0&id=6e4678fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e4678fc"]])

export default __exports__